<template>
    <div style="background-color: #fafafa;">
		<div class="searchBox">
			<van-search class="search-box" background="#2D7FC7" shape="round" v-model="value" placeholder="搜索客户、地址和电话、经销商" show-action @search="onSearch" @input="onSearch"
						@cancel="onSearch" @clear="onSearch">
				<div slot="action" @click="onSearch"></div>
			</van-search>
		</div>
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
			<van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="没有更多了">
				<div style="width: 100%;" v-for="(item, index) in list" class="card" :key="item.uuid">
					<table class="layout" style="width: 100%;" >
						<tr style="width: 100%;">
							<td style="width: 50%;">
								<div class="header" @click="openDetail(item.uuid, item.serialNumber, item.orderStatusname, item.creatorIdname)">
									<span class="title">{{item.serialNumber}}</span>
								</div>
							</td>
							<td style="width: 50%;text-align: left;">
								<div style="width: 100%;display: inline-block; position: relative;">
								    <span style="color: red;font-weight: bold;">{{item.orderStatusname}}</span>&nbsp;&nbsp;
									<van-icon v-if="orderStatus === '8'" @click="auditOrderForm(item.workFlowId, 2)" name="close" size="30px" style="position: absolute;right: 50px;top: -5px;"/>
									<van-icon v-if="orderStatus === '8'"  @click="auditOrderForm(item.workFlowId, 1)" name="passed" size="30px" style="position: absolute;right: 15px;bottom: -8px;"/>
								</div>
							</td>
						</tr>
						<tr style="width: 100%;">
							<td colspan="2" class="content" style="width: 100%;">
								<p><span>收货人：</span><span>{{item.customerName}}</span></p>
								<p><span>联系方式：</span><span>{{item.arrivalMobile}}</span></p>
								<p style="width: 100%;"><span>收货地址：</span><span>{{item.arrivalAddress}}</span></p>
							</td>
						</tr>
						<tr style="width: 100%;">
							<td class="content" style="width: 50%;">
								<p><span>下单人:</span><span>{{item.creatorIdname}}</span></p>
								<p><span>{{item.createTime}}</span></p>
							</td>
							<td class="content" style="width: 50%;font-size: 15px;">
								<p><span>共{{item.mainQuantities}}组,合计:</span></p>
								<p><span>¥{{item.mainCostAmount}}</span></p>
								<p v-if="isLeader === '1'"><span style="color: #ff3300">{{item.mainAmount}}</span></p>
							</td>
						</tr>
					</table>
				</div>
			</van-list>
		</van-pull-refresh>
		<div class="recordBox">
			<table style="width: 100%;margin-bottom: 3px;border-spacing:0;">
				<tr style="height:35px;padding: 0;">
					<td style="width: 50%;background-color:#1989fa;" >
						<van-button type="info" native-type="button" size="large" @click="refreshDataList()">{{btnName}}</van-button>
					</td>
				</tr>
			</table>
		</div>
    </div>
</template>

<script>
	import {Tab, Tabs, Panel, Button, List, Search, Popup, PullRefresh, NavBar, Icon, Toast} from 'vant';
	import dealerOrderService from "../../service/dealerOrderService";
	import VanFieldAcb from '../../components/VanFieldAcb';
	import VanFieldDate from "../../components/VantFieldDate";
    import {formatDictionary} from "../../utils/dictionary";
	import moment from "moment";
	import formService from "../../service/formService";
    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				value: '',
				orderStatus: "8",
				dealerId: "",
				isLeader: "2",
				btnName: "查看已审批"
            }
        },
      
        components: {
			VanFieldAcb,
			VanFieldDate,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
			[NavBar.name]: NavBar,
        },
		created: async function () {
			let resp = await dealerOrderService.getDealerInfo();
			if (resp.data.Status === "1" && resp.data.Data) {
				this.isLeader = resp.data.Data.isLeader || "2";
				this.dealerId = resp.data.Data.uuid || "";
			}
		},
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await dealerOrderService.getMyRadOrderList(this.pageIndex, this.value, this.orderStatus, this.dealerId);
                resp.data.Data.data.forEach(item => {
                    item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm');
					if(item.remark && item.remark.length > 22){
						let temp = item.remark;
						item.remark = temp.substring(0, 22);
						item.remark += "...";
					}
                });
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
            },
            onRefresh() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
			onSearch() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
			openDetail(orderId, serialNumber, orderStatus, staffName){
				this.$router.push({path:"/rad/orderDetail",  query:{uuid: orderId, serialNumber: serialNumber, orderStatus: orderStatus, staffName: staffName, isLeader: this.isLeader}} );
			},
			refreshDataList(){
            	if(this.orderStatus === "8"){
            		this.orderStatus = "1";
            		this.value = "";
            		this.onSearch();
            		this.btnName = "返回待我审批";
				}else{
					this.orderStatus = "8";
					this.value = "";
					this.onSearch();
					this.btnName = "查看已审批";
				}
			},
			async auditOrderForm(workflowId, type) {
				Toast.loading({
					duration:0,
					message: '处理中...',
					forbidClick: true
				});
				let resp = await formService.auditForm(workflowId, type, type === 1 ? "通过" : "否决","",  "");
				if (resp.data.Status === "1") {
					Toast.clear();
					Toast.success('操作成功！');
					this.onSearch();
				} else {
					Toast.clear();
					Toast.fail(resp.data.Data);
					this.onSearch();
				}
			},
        }
    };

</script>
<style>
	.card p {
		margin:10px 0;
	}
	.card p>span:first-child {
		flex: 0 0 4rem;
		text-align: right;
		margin-right: 20px;
	}
	.van-pull-refresh__head{
		display: none;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
	.psiConfirmCont{
		width:100%;
		margin:0 auto;
		overflow: hidden;

	}
	.searchBox {
		height: 3rem;
		box-sizing: border-box;
		margin-bottom: 2rem;
		top: 0;
		position:fixed;
		width: 100%;
		background-color: #2D7FC7;
		z-index:999;
	}
</style>